// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2aoN8","containerItemsCenter":"Skeleton_containerItemsCenter__3jk-x"};